import styled from 'styled-components'

export const Page = styled.div`
    padding: 5rem 0 3% 3%;
`

export const Logo = styled.h1`
    margin: 0;
    letter-spacing: 3px;
    font-size: 1rem;
    font-weight: 500;
    font-size: 1.2rem;
`

export const FloatingButton = styled.div`
font-weight: bold;
position: absolute;
top: 1rem;
right: 1rem;
cursor: pointer;

color: ${
    props => props.buttonType === "info" ? "rgb(179, 221, 28)" : "black"
};

&:hover {
    color: black;
}
`

export const DownloadButton = styled.button`
    position: relative;
    margin-right: 1rem;
    width: 13rem;
    height: 2rem;
    background: ${
        props => props.theme === "off" ? "#666" :
        "rgb(28, 160, 221)"
    };
    color: white;
    border-style: none;
    border-top: ${ props => props.fixed === "down" ? "solid" : "none" };
    border-width: 1px;
    font-size: 0.9rem;
    letter-spacing: 1.5px; 

    transition: ease 0.4;

    &:hover {
        cursor: pointer;
        transition: ease 0.4;
        background: ${
            props => props.theme === "off" ? "#666" :
            "linear-gradient(to right, rgb(21, 92, 199), rgb(22, 125, 194));"
        };
    }

    &:focus {
        outline: none;
    }

    &:active {
        background: ${
            props => props.theme === "off" ? "#666" :
            "linear-gradient(to right, rgb(22, 125, 194), rgb(21, 92, 199));"
        };
    }

    @media (max-width: 600px) {
        vertical-align: bottom;
        width: 7rem;
        font-size: 0.75rem;
        margin-right: 0.6rem;
    }
`
